/**
 * Petstyle24 – Bewertungen: Echtheits-Hinweis als Fenster (sections/product-reviews.liquid; Go-live-Runde,
 * Et. 16 Pflichtteil, D-050 Nr. 5, D-055 Nr. 1 und 4, KI-85).
 *
 * Die Link-Zeile [data-ps-reviews-trust] öffnet den Dialog aus aria-controls, der Knopf [data-ps-reviews-close]
 * schließt ihn – beides ausschließlich über Petstyle24.dialog (Startfokus, Esc, Scrim, Fokus-Rückgabe, Touch-Startfokus
 * ohne Ring; Scroll-Lock über das Attribut scroll-lock, critical.css). Keine Texte im Skript, kein Netz, kein
 * Browser-Speicher, kein Einfügen von HTML, keine Konsolen-Ausgaben. Im Theme-Editor neu geladene Sections
 * (shopify:section:load) werden erneut verbunden.
 */
(() => {
  'use strict';

  const PS = window.Petstyle24;
  if (!PS || !PS.dialog) return;

  const bound = new WeakSet();

  const bind = (root) => {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('[data-ps-reviews-trust]').forEach((trigger) => {
      if (bound.has(trigger)) return;
      bound.add(trigger);
      const dialog = document.getElementById(trigger.getAttribute('aria-controls') || '');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      trigger.addEventListener('click', () => {
        PS.dialog.open(dialog, trigger);
      });
      dialog.querySelectorAll('[data-ps-reviews-close]').forEach((close) => {
        close.addEventListener('click', () => {
          PS.dialog.close(dialog);
        });
      });
    });
  };

  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
